module.exports = __webpack_public_path__ + "img/physics.9b9f6266.svg";